export enum AOC_BATCH_STATUS {
  OPEN = 'OPEN',
  REFERBACK = 'REFERBACK',
  APPROVED = 'APPROVED',
  VOID = 'VOID',
  PENDING = 'PENDING',
  RESUBMIT = 'RESUBMIT',
}
